// extracted by mini-css-extract-plugin
export default {"faqStyles":"Faq_faqStyles__bSNu5","faqList":"Faq_faqList__4QxHf"};